import { Skeleton, styled, tooltipClasses } from "@mui/material";
import { Tooltip } from "@pmag/ui-components";

export const ExplosionGraphicTooltipStyled = styled(Tooltip)(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: "480px",
    },
}));

export const ExplosionGraphicSkeleton = styled(Skeleton)(() => ({
    minWidth: "400px",
    aspectRatio: 1,
}));

export const ExplosionGraphic = styled("img")(() => ({
    maxWidth: "250px",
    height: "auto",
}));
